import cryptoBase64 from 'crypto-js/enc-base64';
import sha256 from 'crypto-js/sha256';
import generateRandomString from './generateRandomString';
function generateCodeChallenge(codeVerifier) {
    return base64URL(sha256(codeVerifier));
}
function base64URL(value) {
    return value
        .toString(cryptoBase64)
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
}
export default function generatePkce() {
    const codeVerifier = generateRandomString(128);
    const codeChallenge = generateCodeChallenge(codeVerifier);
    return {
        codeVerifier: codeVerifier,
        codeChallenge: codeChallenge,
    };
}
//# sourceMappingURL=generatePkce.js.map